<template>
  <div :class="showExpand ? 'my-4' : ''">
    <v-card
      hover
      :class="$vuetify.dark ? 'card-dark ma-2 pa-1 ' : 'card-light ma-2 pa-1 '"
      style="border-radius: 10px"
    >
      <v-card-title class="pa-1">
        <v-chip
          v-if="this.taskView === 'claimed'"
          outline
          :color="getTaskType() === 'FORM_TASK' ? 'secondary' : 'accent'"
        >
          <span> {{ getTaskTypeCaption() }}</span>
        </v-chip>
        <v-chip
          v-else-if="this.taskView === 'unclaimed'"
          outline
          :color="this.groupItem.claimable ? 'secondary' : 'accent'"
        >
          <span>
            {{ this.groupItem.claimable ? 'Un Assigned' : 'Assigned' }}</span
          >
        </v-chip>
        <v-chip v-if="this.groupItem.inProgress" outline color="secondary">
          <v-progress-circular
            :width="3"
            :size="20"
            indeterminate
          ></v-progress-circular
          >&nbsp; <span> Tasks being processed</span>
        </v-chip>
        <v-progress-linear
          color="accent"
          indeterminate
          v-if="approveRejectLoader"
        ></v-progress-linear>
        <v-tooltip bottom>
          <v-btn
            slot="activator"
            icon
            flat
            class="mr-2"
            @click.stop="expandGroup()"
          >
            <v-icon>{{ showExpand ? 'remove' : 'add' }}</v-icon>
          </v-btn>
          <span>{{ showExpand ? 'Collapse' : 'Expand' }}</span>
        </v-tooltip>
        <v-spacer />
        <v-btn
          flat
          class="mt-2 text-capitalize primary"
          outline
          v-if="taskView === 'unclaimed' && this.groupItem.claimable"
          :loading="claimAllLoader || this.groupItem.inProgress"
          :disabled="tasksInProgress"
          @click.stop="confirmClaimAllAction()"
        >
          Claim All
        </v-btn>
        <v-btn
          flat
          class="mt-2 text-capitalize red"
          outline
          v-if="
            taskView === 'claimed' &&
              groupItem.taskType !== null &&
              getTaskType() !== 'FORM_TASK'
          "
          :loading="approveRejectLoader || this.groupItem.inProgress"
          :disabled="tasksInProgress"
          @click.stop="confirmApproveRejectAction(false)"
        >
          Reject All
        </v-btn>
        <v-btn
          flat
          class="mt-2 text-capitalize green"
          outline
          v-if="
            taskView === 'claimed' &&
              groupItem.taskType !== null &&
              getTaskType() !== 'FORM_TASK'
          "
          :loading="approveRejectLoader || this.groupItem.inProgress"
          :disabled="tasksInProgress"
          @click.stop="confirmApproveRejectAction(true)"
        >
          Approve All
        </v-btn>
      </v-card-title>
      <!--           Group By Expansion -->
      <div>
        <v-layout align-start fill-height justify-start row wrap>
          <v-flex class="mx-3" xs12 sm12 md4 lg3>
            <div align="left" class="pt-1" style="font-size: 1.0em;">
              <div class="mb-1">
                Number of tasks
              </div>
              <div>
                <span style="font-size: 1.0em" class="pr-2">EA</span>
                <span style="font-size: 1.5em; font-weight: 500">{{
                  groupItem.noOfTasks || groupItem.tasks.length
                }}</span>
              </div>
              <v-chip v-if="tasksInProgress" class="accent" outline
                ><span>In Progress</span>
              </v-chip>
            </div>
          </v-flex>
          <v-flex class="mx-3" lg3 md4 sm12 xs12>
            <div align="left" class="pt-1" style="font-size: 1.0em;">
              <div class="mb-1">Grouped By: {{ groupItem.groupName }}</div>
              <div>
                <span style="font-size: 1.2em; font-weight: 500">{{
                  getGroupByValue
                }}</span>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-expand-transition>
          <v-flex v-if="showExpand" class="pt-0">
            <v-progress-linear
              v-if="taskLoader"
              class="ma-2"
              color="accent"
              indeterminate
            ></v-progress-linear>
            <v-layout row wrap>
              <v-flex xs12>
                <template v-for="(groupTaskItem, groupItemIndex) in taskItems">
                  <task-card
                    :in-group="true"
                    :show-time="showTime"
                    :show-toolbar="true"
                    :task-id="groupTaskItem.id"
                    :task-view="taskView"
                    :task-number="groupItemIndex"
                    :selected-task-id="selectedTaskId"
                    :task-action="false"
                    @task-selected="setSelectedTask"
                    @task-refresh="notifyTaskListRefresh"
                    :key="groupItemIndex + '-task-card-group-item'"
                  />
                </template>
              </v-flex>
            </v-layout>
            <div v-if="taskItems.length < groupItem.noOfTasks">
              <v-progress-linear
                :value="taskShownPercent"
                :indeterminate="taskLoader"
              ></v-progress-linear>
              <template>
                <v-btn
                  outline
                  color="primary"
                  @click="appendTasks"
                  class="text-capitalize"
                  style="border-radius: 5px"
                >
                  Load More tasks, currently loaded {{ taskItems.length }} /
                  {{ groupItem.noOfTasks }} tasks
                </v-btn>
              </template>
            </div>
          </v-flex>
        </v-expand-transition>
        <!--      <template>-->
        <!--        <div id="scrollTriggerGroupCard"></div>-->
        <!--      </template>-->
      </div>
      <v-dialog v-model="confirmClaimDialog" max-width="500px">
        <v-card>
          <v-card-title class="body-2 beez-bold ">
            Confirm Claim All Task
          </v-card-title>
          <v-card-text class="body-2 beez-bold ">
            Confirm to claim all the grouped tasks?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              class="mt-2 text-capitalize"
              outline
              :loading="claimAllLoader"
              @click.stop="confirmClaimDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              flat
              class="mt-2 text-capitalize primary"
              outline
              :loading="claimAllLoader"
              @click.stop="handleClaimAllAction()"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirmDialog" max-width="600px">
        <v-card>
          <v-card-title align="left" class="pb-1">
            Confirm to &emsp13;
            <b>{{ confirmAction ? ' Approve ' : ' Reject ' }}</b> &emsp13; the
            &emsp13; <b>{{ groupItem.noOfTasks }}</b> &emsp13; tasks?
          </v-card-title>
          <v-textarea
            v-model="remarks"
            hint="Please enter the approver remarks (minimum of 2 characters)"
            label="Remarks"
            class="px-3"
            outline
          >
          </v-textarea>
          <file-input
            :options="attachmentOptions"
            @filepick="updateFileLink"
          ></file-input>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              class="mt-2 text-capitalize"
              outline
              v-if="taskView === 'claimed'"
              :loading="approveRejectLoader"
              @click.stop="confirmDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              flat
              class="mt-2 text-capitalize"
              outline
              v-if="taskView === 'claimed'"
              :loading="approveRejectLoader"
              :disabled="checkRemarks"
              @click.stop="handleApproveRejectAction()"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import TaskCard from './TaskCard'
import moment from 'moment'
import FileInput from '@/components/common/form-generator/FileInput'
import { mapState } from 'vuex'
// import debounce from 'lodash/debounce'

export default {
  name: 'TaskGroupCard',
  components: { TaskCard, FileInput },
  props: {
    groupId: String,
    selectedGroupId: String,
    groupItem: Object,
    selectedTaskId: String,
    taskView: String,
    filterObj: {
      type: Object,
      default: null
    },
    showTime: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      taskItems: [],
      attachmentOptions: {
        name: 'fileinput',
        acceptFormats: '',
        multiple: 'true'
      },
      // scrollTriggerGroupCard: null,
      fileAttachments: [],
      confirmDialog: false,
      confirmClaimDialog: false,
      confirmAction: false,
      showExpand: false,
      approveRejectLoader: false,
      claimAllLoader: false,
      tasksInProgress: false,
      taskLoader: false,
      remarks: ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.session.user,
      associatedFormKeys: state => state.tasks.associatedFormKeys,
      claimedGroupTaskItems: state => state.tasks.claimedGroupTaskItems,
      unClaimedGroupTaskItems: state => state.tasks.unClaimedGroupTaskItems,
      totalClaimedGroupTaskItems: state =>
        state.tasks.totalClaimedGroupTaskItems,
      totalUnClaimedGroupTaskItems: state =>
        state.tasks.totalUnClaimedGroupTaskItems
    }),
    checkRemarks() {
      return this.remarks.length < 2
    },
    getGroupByValue() {
      switch (this.groupItem.value) {
        case 'formKey':
          return this.associatedFormKeys[this.groupItem.label]
        case 'createdAt':
        case 'due':
          return moment(this.groupItem.label, 'YYYY-MM-DD')
            .utc()
            .local()
            .format('DD MMMM YYYY')
        default:
          return this.groupItem.label
      }
    },
    taskShownPercent() {
      return Math.round(
        (this.taskItems.length / this.groupItem.noOfTasks) * 100
      )
    }
  },
  watch: {
    claimedGroupTaskItems() {
      if (this.taskView === 'claimed') {
        this.taskItems = this.claimedGroupTaskItems
      }
    },
    unClaimedGroupTaskItems() {
      if (this.taskView === 'unclaimed') {
        this.taskItems = this.unClaimedGroupTaskItems
      }
    },
    groupItem() {
      this.tasksInProgress = !!this.groupItem.tasks.find(
        item => item.inProgress === true
      )
    },
    selectedGroupId() {
      this.showExpand = this.selectedGroupId === this.groupId
    }
  },
  mounted() {
    if (this.taskView === 'claimed') {
      this.taskItems = this.claimedGroupTaskItems
    } else if (this.taskView === 'unclaimed') {
      this.taskItems = this.unClaimedGroupTaskItems
    }
  },
  // beforeDestroy() {
  //   this.removeScrollListener()
  // },
  methods: {
    getTaskType() {
      if (this.groupItem.taskType === 1) {
        return 'FORM_TASK'
      } else if (this.groupItem.taskType === 0) {
        return 'APPROVAL_TASK'
      } else {
        return null
      }
    },
    getTaskTypeCaption() {
      if (this.groupItem.taskType === 1) {
        return 'User Input Task'
      } else if (this.groupItem.taskType === 0) {
        return 'Approval Task'
      } else {
        return 'Empty Task'
      }
    },
    // addScrollListener() {
    //   this.scrollTriggerGroupCard = document.getElementById(
    //     'scrollTriggerGroupCard'
    //   )
    //   this.handleDebouncedScroll = debounce(this.handleScroll, 100)
    //   window.addEventListener('scroll', this.handleDebouncedScroll)
    // },
    // removeScrollListener() {
    //   window.removeEventListener('scroll', this.handleDebouncedScroll)
    // },
    // handleScroll() {
    //   if (this.scrollTriggerGroupCard) {
    //     this.checkForMoreTasks()
    //   }
    // },
    // checkForMoreTasks() {
    //   if (this.selectedGroupId === this.groupId && !this.taskLoader) {
    //     let func = debounce(async () => {
    //       await this.appendTasks()
    //     }, 500)
    //     let totalTask =
    //       this.taskView === 'claimed'
    //         ? this.totalClaimedGroupTaskItems
    //         : this.totalUnClaimedGroupTaskItems
    //     if (this.taskItems.length < totalTask) {
    //       func()
    //     }
    //   }
    // },
    updateFileLink: function(link) {
      this.fileAttachments = link
    },
    setSelectedTask(taskId) {
      this.$emit('task-selected', taskId)
    },
    notifyTaskListRefresh() {
      this.refreshTasks()
      this.$emit('task-refresh')
    },
    numberFormat(param) {
      return parseFloat(param).toLocaleString()
    },
    async expandGroup() {
      this.showExpand = !this.showExpand
      if (this.showExpand) {
        this.$emit('group-selected', this.groupId)
        // this.addScrollListener()
        await this.fetchGroupTaskItems(1, 10)
      } else {
        // this.removeScrollListener()
        this.$emit('task-selected', null)
      }
    },
    fillUrlParams: function(urlParams) {
      if (this.filterObj !== null && this.filterObj.urlString) {
        urlParams = urlParams + this.filterObj.urlString
      }
      if (this.groupItem.dimension) {
        urlParams =
          urlParams +
          `&${this.groupItem.dimension}=${this.groupItem.groupName}&${this.groupItem.valueField}=${this.groupItem.label}`
      } else {
        switch (this.groupItem.value) {
          case 'createdAt':
            if (
              this.groupItem.label !== null &&
              this.groupItem.label !== undefined &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== null &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== undefined
            ) {
              urlParams =
                urlParams +
                `&fromDate=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                ).toISOString()}&toDate=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                )
                  .add(1, 'd')
                  .toISOString()}`
            }
            break
          case 'due':
            if (
              this.groupItem.label !== null &&
              this.groupItem.label !== undefined &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== null &&
              moment(this.groupItem.label, 'YYYY-MM-DD') !== undefined
            ) {
              urlParams =
                urlParams +
                `&dueFrom=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                ).toISOString()}&dueTill=${moment(
                  this.groupItem.label,
                  'YYYY-MM-DD'
                )
                  .add(1, 'd')
                  .toISOString()}`
            }
            break
          default:
            let value = null
            if (this.groupItem.label === undefined) {
              value = null
            } else {
              value = this.groupItem.label
            }
            urlParams = urlParams + `&${this.groupItem.value}=${value}`
            break
        }
      }
      if (this.taskView === 'claimed') {
        urlParams = urlParams + `&taskType=${this.getTaskType()}`
      } else if (this.taskView === 'unclaimed') {
        urlParams = urlParams + `&claimable=${this.groupItem.claimable}`
      }
      if (this.groupItem.inProgress) {
        urlParams = urlParams + `&inProgress=true`
      } else {
        urlParams = urlParams + `&inProgress=false`
      }
      return urlParams
    },

    async refreshTasks() {
      if (this.taskItems.length > 0) {
        await this.fetchGroupTaskItems(1, this.taskItems.length)
      }
    },

    async appendTasks() {
      this.taskLoader = true
      if (this.taskItems.length >= 10) {
        let currentPage = Math.floor(this.taskItems.length / 10) + 1
        let urlParams = `page=${currentPage}&size=${10}`
        urlParams = this.fillUrlParams(urlParams)
        try {
          if (this.taskView === 'claimed') {
            await this.$store.dispatch(
              'appendSetClaimedGroupTaskItems',
              urlParams
            )
          } else if (this.taskView === 'unclaimed') {
            await this.$store.dispatch(
              'appendSetUnClaimedGroupTaskItems',
              urlParams
            )
          }
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            message: 'Unable to Fetch the Tasks',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            type: 'error',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
      this.taskLoader = false
    },

    async fetchGroupTaskItems(page, size) {
      this.taskLoader = true
      let urlParams = `page=${page}&size=${size}`
      urlParams = this.fillUrlParams(urlParams)
      try {
        if (this.taskView === 'claimed') {
          await this.$store.dispatch('fetchSetClaimedGroupTaskItems', urlParams)
        } else if (this.taskView === 'unclaimed') {
          await this.$store.dispatch(
            'fetchSetUnClaimedGroupTaskItems',
            urlParams
          )
        }
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to Fetch the Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskLoader = false
    },

    async handleRejectAllGroupTask() {
      this.approveRejectLoader = true
      await this.completeTaskListActionDirect(false)
      this.approveRejectLoader = false
      this.tasksInProgress = true
      this.notifyTaskListRefresh()
    },
    async handleApproveAllGroupTask() {
      this.approveRejectLoader = true
      await this.completeTaskListActionDirect(true)
      this.approveRejectLoader = false
      this.tasksInProgress = true
      this.notifyTaskListRefresh()
    },
    async confirmApproveRejectAction(approved) {
      this.confirmAction = approved
      this.confirmDialog = true
    },
    async confirmClaimAllAction() {
      this.confirmClaimDialog = true
    },
    async handleClaimAllAction() {
      this.claimAllLoader = true
      try {
        let urlParams = ''
        urlParams = this.fillUrlParams(urlParams)
        let taskIds = await this.$store.dispatch(
          'setAllTasksInProgress',
          urlParams
        )
        let req = {}
        req.urlParams = urlParams
        req.body = taskIds
        let response = await this.$store.dispatch('claimAllTask', req)
        if (response && response.length > 0) {
          for (const item of response) {
            await this.$store.dispatch('directNotification', {
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
              message: item.message,
              description: 'User Task: ' + item.taskId + ' , ' + item.message,
              type: item.status,
              hideNotification: true
            })
          }
          await this.$store.dispatch('directNotification', {
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
            message: 'Bulk request placed!',
            description:
              'Bulk request for claim task placed, Please check the notifications for individual status',
            type: 'info'
          })
        }
        await this.fetchGroupTaskItems(1, 10)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to claiming all/some of the selected group Tasks',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.confirmClaimDialog = false
      this.claimAllLoader = false
      this.notifyTaskListRefresh()
    },
    async handleApproveRejectAction() {
      if (this.confirmAction) {
        await this.handleApproveAllGroupTask()
      } else {
        await this.handleRejectAllGroupTask()
      }
      this.confirmDialog = false
    },
    async completeTaskListActionDirect(approved) {
      this.taskCompleteLoader = true
      try {
        let urlParams = ''
        urlParams = this.fillUrlParams(urlParams)
        let taskIds = await this.$store.dispatch(
          'setAllTasksInProgress',
          urlParams
        )

        let body = {}
        body.remarks = this.remarks
        body.fileAttachment = this.fileAttachments
        body.approval = approved
        body.taskIds = taskIds

        this.$store
          .dispatch('completeTaskListDirect', {
            body: body,
            urlParams: urlParams
          })
          .then(response => {
            if (response && response.length > 0) {
              for (const item of response) {
                this.$store.dispatch('directNotification', {
                  timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
                  message: item.message,
                  description:
                    'User Task: ' + item.taskId + ' , ' + item.message,
                  type: item.status,
                  hideNotification: true
                })
              }
            }
          })
          .catch(e => {
            this.$store.dispatch('directNotification', {
              message:
                'Unable to complete all/some of the selected group Tasks',
              description: e.response
                ? e.response.data.message
                : 'Error unknown! Kindly retry',
              type: 'error',
              timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
            })
          })

        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Bulk request placed!',
          description:
            'Bulk request placed, Please check the notifications for individual status',
          type: 'info'
        })
        await this.fetchGroupTaskItems(1, 10)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Unable to complete the Task',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.taskCompleteLoader = false
    }
  }
}
</script>

<style scoped></style>
